import CrossSolid from '@simplywallst/ui-core/icons/CrossSolid';

interface Props {
  onClick: () => void;
}

export const CloseIcon = ({ onClick }: Props) => {
  return (
    <div className="absolute right-2 top-2 z-1 cursor-pointer">
      <CrossSolid fill="black" data-cy-id="close-button" onClick={onClick} />
    </div>
  );
};
